import {
  getArticleEditorialChecklist,
  type ArticleEditor,
} from "@/core/services/types/article.types";
import { ArticleEditorialChecklistItems } from "@/components/ui/admin/articles/ArticleEditorialChecklistItems";

type ArticleEditorialChecklistProps = {
  article: ArticleEditor;
};

export function ArticleEditorialChecklist({
  article,
}: ArticleEditorialChecklistProps) {
  const checklist = getArticleEditorialChecklist(article);

  return (
    <section className="wireframe-border bg-white p-5">
      <ArticleEditorialChecklistItems
        checklist={checklist}
        showLabel={false}
        className="space-y-3"
      />
    </section>
  );
}
